import type { ReactNode } from 'react';

// PageHeader: einheitlicher Seitenkopf – Titel, eine Zeile Erklärung darunter, Hauptaktionen rechts.
export function PageHeader({ title, description, actions }: { title: ReactNode; description?: ReactNode; actions?: ReactNode }) {
  return (
    <header className="page-header page-head">
      <div className="page-head-text">
        <h1>{title}</h1>
        {description && <p className="page-description">{description}</p>}
      </div>
      {actions && <div className="page-head-actions">{actions}</div>}
    </header>
  );
}
